import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import Select from "react-select";
import uuid from "react-uuid";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/forms.css";
import { useMutation } from "@apollo/client";
import { REQUEST_FORM_SURVEYOR_MUTATATION } from "../../GraphQl/Mutations";
import { FaSpinner } from "react-icons/fa";
import Loader from "../../components/Loader";
const RequestForms = () => {
  const [formMetaData, setFormMetaData] = useState({
    description: null,
    formTitle: null,
    formType: null,
  });
  const [message, setMessage] = useState("");
  const [formQuestions, setFormQuestions] = useState([
    {
      questionTitle: "Question 1",
      questionType: "text",
      questionMetadata: null,
    },
  ]);
  const profile = useSelector((state) => state?.users?.user);
  const [requestForm, { loading }] = useMutation(
    REQUEST_FORM_SURVEYOR_MUTATATION,
    {
      onCompleted: () => {
        setMessage("Request received successfully!");
      },
      onError: () => {
        setMessage("Couldn't receive request!");
      },
    }
  );

  const addQuestion = () => {
    setFormQuestions([
      ...formQuestions,
      {
        questionTitle: `Question ${formQuestions.length + 1}`,
        questionType: "text",
        questionMetadata: null,
      },
    ]);
  };
  const updateQuestion = (type, question, idx) => {
    let newQues = structuredClone(formQuestions);
    switch (type) {
      case "title":
        newQues[idx].questionTitle = question;
        break;
      case "type":
        if (type !== "radio" || type !== "checkbox")
          newQues[idx].questionMetadata = "";
        newQues[idx].questionType = question;
        break;
      case "options":
        newQues[idx].questionMetadata = question;
        break;
      default:
        break;
    }
    setFormQuestions(newQues);
  };
  const removeQuestion = (question) => {
    setFormQuestions(formQuestions.filter((e) => e.id !== question));
  };

  const handleRequest = () => {
    setMessage("");

    requestForm({
      variables: {
        requestFormData: {
          description: formMetaData?.description,
          formTitle: formMetaData?.formTitle,
          formType: formMetaData?.formType,
          questions: formQuestions,
          requestedSurveyor: {
            email: profile?.email,
            fullName: profile?.fullName,
            phone: profile?.phone,
          },
        },
      },
    });
  };
  return (
    <section className='manageFormWrapper'>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Request a form </div>
      </div>

      <div className='sectionContentWrapper'>
        <form
          className='reqForm'
          onSubmit={(e) => {
            e.preventDefault();
            handleRequest();
          }}
        >
          <div className='formControlDiv flex flex-col items-start'>
            <label>Form Title</label>
            <input
              required
              type='text'
              placeholder='Enter a form Title'
              className='form-control reqFormControl'
              onKeyUp={(e) =>
                setFormMetaData({ ...formMetaData, formTitle: e.target.value })
              }
            />
          </div>
          <div className='formControlDiv flex flex-col items-start'>
            <label>Form Description</label>
            <input
              required
              type='text'
              placeholder='Enter a form Description'
              className='form-control reqFormControl'
              onKeyUp={(e) =>
                setFormMetaData({
                  ...formMetaData,
                  description: e.target.value,
                })
              }
            />
          </div>
          <div className='formControlDiv flex flex-col items-start'>
            <label>Form Type</label>
            <Select
              className='reqFormControl'
              classNamePrefix='select'
              isClearable={true}
              isSearchable={true}
              name='color'
              options={[
                { value: "Survey", label: "Survey" },
                { value: "Quiz", label: "Quiz" },
                { value: "Feedback", label: "Feedback" },
                { value: "Marketing Survey", label: "Marketing Survey" },
              ]}
              onChange={(e) =>
                setFormMetaData({
                  ...formMetaData,
                  formType: e.value,
                })
              }
            />
          </div>
          {/* <div className="formControlDiv flex flex-col items-start">
            <label>Form Questions</label>
            <input
            required
              type="text"
              placeholder="Enter a form Description"
              className="form-control reqFormControl"
            />
          </div> */}
          <div className='formControlDiv flex flex-col items-start'>
            <label>Form Questions</label>
            {formQuestions?.map((card, idx) => (
              <>
                {/* {card?.questionType === "CheckBox" ||
                card?.questionType === "Radio" ? ( */}
                <div className='reqFormQuestionWrapper'>
                  <div className='reqFormQuestion'>
                    <label htmlFor={card?.id}>Enter Question Title</label>
                    <input
                      required
                      type='text'
                      placeholder='Enter a form Description'
                      className='form-control reqFormControl'
                      value={card?.questionTitle}
                      onChange={(e) =>
                        updateQuestion("title", e.target.value, idx)
                      }
                    />
                    <label htmlFor={card?.id}>Enter Question Type</label>
                    <select
                      className='form-control form-select reqFormControl'
                      onChange={
                        (e) => updateQuestion("type", e.target.value, idx)
                        // console.log(e.target.value)
                      }
                    >
                      <option
                        value='text'
                        selected={card?.questionType == "text"}
                      >
                        Text
                      </option>
                      <option
                        value='checkbox'
                        selected={card?.questionType == "checkbox"}
                      >
                        CheckBox
                      </option>
                      <option
                        value='radio'
                        selected={card?.questionType == "radio"}
                      >
                        Radio
                      </option>
                      <option
                        value='range'
                        selected={card?.questionType == "range"}
                      >
                        Range
                      </option>
                    </select>
                    {(card?.questionType === "checkbox" ||
                      card?.questionType === "radio") && (
                      <>
                        <label htmlFor={card?.id}>
                          Enter Options (separated by comma)
                        </label>

                        <input
                          required
                          type='text'
                          placeholder='Enter Options (separated by comma)'
                          className='form-control reqFormControl'
                          value={card?.metadata}
                          onChange={(e) =>
                            updateQuestion("options", e.target.value, idx)
                          }
                        />
                      </>
                    )}
                  </div>
                  <div
                    className='crossBtn'
                    onClick={() => removeQuestion(card?.id)}
                  >
                    <MdDelete />
                  </div>
                </div>
              </>
            ))}

            <div
              className='btn btn-secondary reqFormQuestionBtn'
              onClick={addQuestion}
            >
              Add Question
            </div>
          </div>

          <button className='btn btn-primary'>
            {loading && <Loader />}Request Form
          </button>
        </form>
        <div className='messageDiv'>{message}</div>
      </div>
    </section>
  );
};

export default RequestForms;
